const dom = {
  defaultVariant: '[data-pdp-selector-input-default]',
  variantLabel: '[data-pdp-selector-variant-label]',
  shopifyPaymentTerms: 'shopify-payment-terms',
};

const defaultVariantID = $(dom.defaultVariant).val();
let currentVariantID = defaultVariantID;

const updateShopPay = () => $(dom.shopifyPaymentTerms).attr('variant-id', currentVariantID);

const bindUIActions = () => {
  $(document).on('click', dom.variantLabel, (event) => {
    const selectedVariantID = $(event.currentTarget).data('variant');

    // default selected
    if (selectedVariantID == currentVariantID) currentVariantID = defaultVariantID;
    // package selected
    else currentVariantID = selectedVariantID;

    setTimeout(updateShopPay, 450); // wait until ShopPay finishes updating itself
  });
};

export const init = () => {
  bindUIActions();
};
